export default __webpack_public_path__ + "static/media/1102.896c201b.jpg";